
import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  addPresetToStoreAndSavePresetsToWordPressIfPresetsPanelIsClosed,
  createElementPresetFromName
} from "@/lib/presets/presets";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { configStore } from "@/store/store";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { BuilderElement } from "@/types/elements";
import { isElementHidden } from "@/lib/elements/utils";

@Component({
  components: { DropdownInput, NiceButton, TextInput }
})
export default class AddPreset extends Vue {
  newPresetName = "";
  newPresetType = "";

  get elements() {
    return configStore.elements;
  }

  get elementsItems() {
    return Object.values(this.elements)
      .filter((element): element is BuilderElement => element !== undefined)
      .filter(
        element => !isElementHidden(element.addPanelRules, element.settings)
      )
      .map(element => ({
        text: element.name,
        value: element?.slug
      }));
  }

  addPreset() {
    if (!this.newPresetName || !this.newPresetType) return;

    const preset = createElementPresetFromName(
      this.newPresetName,
      this.newPresetType
    );

    addPresetToStoreAndSavePresetsToWordPressIfPresetsPanelIsClosed(preset);

    this.newPresetName = "";
    this.newPresetType = "";
  }
}
